import React, { useEffect, useState, useCallback } from 'react';
import api from '../api';

const DURUMLAR = {
  BASVURU: { etiket: 'Beklemede', renk: '#1565c0' },
  ON_KONTROL: { etiket: 'Beklemede', renk: '#e65100' },
  SON_KONTROL: { etiket: 'Son Kontrol Bekliyor', renk: '#6a1b9a' },
  ONAYLANDI: { etiket: 'Tamamlandı', renk: '#1b5e20' },
  IPTAL: { etiket: 'İptal Ruhsat', renk: '#b71c1c' },
  ASKIDA: { etiket: 'Beklemede', renk: '#616161' },
  INTIKAL_RUHSAT: { etiket: 'İntikal Ruhsat', renk: '#0f766e' },
};

const AYLAR = ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'];
const AY_ADLARI = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

const suankiYil = new Date().getFullYear();
const YILLAR = Array.from({ length: 10 }, (_, i) => suankiYil - i);

export default function Dashboard() {
  const [istatistik, setIstatistik] = useState(null);
  const [ekstraIst, setEkstraIst] = useState({ bekSikayet:0, aktifYaptirim:0, odenmemisHarc:0, planliDenetim:0 });
  const [vadesiYaklasan, setVadesiYaklasan] = useState(0);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [yil, setYil] = useState(suankiYil);
  const [ay, setAy] = useState(0); // 0 = tüm yıl

  const yukleIstatistik = useCallback(() => {
    setYukleniyor(true);
    const params = `yil=${yil}${ay > 0 ? `&ay=${ay}` : ''}`;
    api.get(`/ruhsat/istatistik/ozet?${params}`)
      .then(r => setIstatistik(r.data))
      .catch(console.error)
      .finally(() => setYukleniyor(false));
  }, [yil, ay]);

  useEffect(() => { yukleIstatistik(); }, [yukleIstatistik]);

  useEffect(() => {
    Promise.all([
      api.get('/sikayet?sonuc=BEKLEMEDE&limit=1').catch(()=>({data:{toplam:0}})),
      api.get('/yaptirim?aktif=true&limit=1').catch(()=>({data:{toplam:0}})),
      api.get('/harc?odendi=false&limit=1').catch(()=>({data:{toplam_tutar:0}})),
      api.get('/denetim?durum=PLANLI&limit=1').catch(()=>({data:{toplam:0}})),
      api.get('/raporlar/vadesi-yaklasan?gun=30').catch(()=>({data:{yaklasan:[],gecmis:[]}})),
    ]).then(([s,y,h,d,v])=>{
      setEkstraIst({ bekSikayet:s.data.toplam||0, aktifYaptirim:y.data.toplam||0, odenmemisHarc:h.data.toplam_tutar||0, planliDenetim:d.data.toplam||0 });
      setVadesiYaklasan((v.data.yaklasan?.length||0) + (v.data.gecmis?.length||0));
    });
  }, []);

  if (yukleniyor) return <div className="loading">Yükleniyor...</div>;
  if (!istatistik) return <div className="alert alert-error">Veriler yüklenemedi</div>;

  const onaylandi = istatistik.durumlara.find(d => d.durum === 'ONAYLANDI')?.sayi || 0;
  const bekleyen = istatistik.durumlara.filter(d => ['BASVURU','ON_KONTROL','SON_KONTROL'].includes(d.durum))
    .reduce((s, d) => s + parseInt(d.sayi), 0);
  const iptal = istatistik.durumlara.find(d => d.durum === 'IPTAL')?.sayi || 0;
  const toplamGosterilen = ay > 0 ? (istatistik.toplam_filtreli || 0) : istatistik.toplam;

  const maxAylik = Math.max(...(istatistik.aylik.map(a => parseInt(a.sayi))), 1);
  const baslik = ay > 0 ? `${AY_ADLARI[ay-1]} ${yil}` : `${yil} Yılı`;

  return (
    <div>
      <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'20px', flexWrap:'wrap', gap:'12px'}}>
        <h2 style={{color:'#1a237e', fontSize:'22px', margin:0}}>
          📊 Dashboard — {baslik} Özeti
        </h2>
        <div style={{display:'flex', gap:'10px', alignItems:'center'}}>
          <select
            value={yil}
            onChange={e => setYil(parseInt(e.target.value))}
            style={{padding:'6px 12px', border:'1px solid #ddd', borderRadius:'6px', fontSize:'14px', background:'#fff'}}
          >
            {YILLAR.map(y => <option key={y} value={y}>{y}</option>)}
          </select>
          <select
            value={ay}
            onChange={e => setAy(parseInt(e.target.value))}
            style={{padding:'6px 12px', border:'1px solid #ddd', borderRadius:'6px', fontSize:'14px', background:'#fff'}}
          >
            <option value={0}>Tüm Yıl</option>
            {AY_ADLARI.map((a, i) => <option key={i+1} value={i+1}>{a}</option>)}
          </select>
        </div>
      </div>

      {/* Seçilen dönem özeti */}
      <div className="stats-grid">
        <div className="stat-card blue">
          <div className="stat-icon">📋</div>
          <div className="stat-info">
            <h3>{toplamGosterilen}</h3>
            <p>{ay > 0 ? `${AY_ADLARI[ay-1]} Toplam` : 'Genel Toplam'}</p>
          </div>
        </div>
        <div className="stat-card green">
          <div className="stat-icon">✅</div>
          <div className="stat-info">
            <h3>{onaylandi}</h3>
            <p>Onaylanan Ruhsat</p>
          </div>
        </div>
        <div className="stat-card orange">
          <div className="stat-icon">⏳</div>
          <div className="stat-info">
            <h3>{bekleyen}</h3>
            <p>Bekleyen Başvuru</p>
          </div>
        </div>
        <div className="stat-card red">
          <div className="stat-icon">❌</div>
          <div className="stat-info">
            <h3>{iptal}</h3>
            <p>İptal Edilen</p>
          </div>
        </div>
      </div>

      <div className="stats-grid" style={{marginTop:'16px'}}>
        <div className="stat-card" style={{background:'linear-gradient(135deg,#e65100,#ff7043)'}}>
          <div className="stat-icon">⚠️</div>
          <div className="stat-info">
            <h3 style={{color:'#fff'}}>{ekstraIst.bekSikayet}</h3>
            <p style={{color:'rgba(255,255,255,0.8)'}}>Bekleyen Şikayet</p>
          </div>
        </div>
        <div className="stat-card" style={{background:'linear-gradient(135deg,#b71c1c,#e53935)'}}>
          <div className="stat-icon">🚫</div>
          <div className="stat-info">
            <h3 style={{color:'#fff'}}>{ekstraIst.aktifYaptirim}</h3>
            <p style={{color:'rgba(255,255,255,0.8)'}}>Aktif Yaptırım</p>
          </div>
        </div>
        <div className="stat-card" style={{background:'linear-gradient(135deg,#1565c0,#1e88e5)'}}>
          <div className="stat-icon">💰</div>
          <div className="stat-info">
            <h3 style={{color:'#fff',fontSize:'18px'}}>{Number(ekstraIst.odenmemisHarc).toLocaleString('tr-TR',{maximumFractionDigits:0})} ₺</h3>
            <p style={{color:'rgba(255,255,255,0.8)'}}>Ödenmemiş Harç</p>
          </div>
        </div>
        <div className="stat-card" style={{background:'linear-gradient(135deg,#1b5e20,#388e3c)'}}>
          <div className="stat-icon">🔍</div>
          <div className="stat-info">
            <h3 style={{color:'#fff'}}>{ekstraIst.planliDenetim}</h3>
            <p style={{color:'rgba(255,255,255,0.8)'}}>Planlanan Denetim</p>
          </div>
        </div>
        <a href="/vadesi-yaklasan" className="stat-card" style={{background:'linear-gradient(135deg,#f57f17,#ffb300)',cursor:'pointer',display:'block',textDecoration:'none'}}>
          <div className="stat-icon">⏰</div>
          <div className="stat-info">
            <h3 style={{color:'#fff'}}>{vadesiYaklasan}</h3>
            <p style={{color:'rgba(255,255,255,0.8)'}}>Vadesi Yaklaşan (30 gün)</p>
          </div>
        </a>
      </div>

      <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'20px'}}>
        {/* Durum dağılımı */}
        <div className="card">
          <div className="card-header">
            <span className="card-title">Durum Dağılımı — {baslik}</span>
          </div>
          {istatistik.durumlara.length === 0
            ? <p style={{color:'#999', fontSize:'13px', textAlign:'center', padding:'20px'}}>Bu dönemde kayıt yok</p>
            : istatistik.durumlara.map(d => {
                const info = DURUMLAR[d.durum] || { etiket: d.durum, renk: '#666' };
                const yuzde = toplamGosterilen > 0 ? (parseInt(d.sayi) / toplamGosterilen * 100).toFixed(1) : 0;
                return (
                  <div key={d.durum} style={{marginBottom:'12px'}}>
                    <div style={{display:'flex', justifyContent:'space-between', marginBottom:'4px'}}>
                      <span style={{fontSize:'13px', fontWeight:'600', color: info.renk}}>{info.etiket}</span>
                      <span style={{fontSize:'13px'}}>{d.sayi} ({yuzde}%)</span>
                    </div>
                    <div style={{height:'8px', background:'#f0f0f0', borderRadius:'4px', overflow:'hidden'}}>
                      <div style={{height:'100%', width:`${yuzde}%`, background: info.renk, borderRadius:'4px', transition:'width 0.5s'}} />
                    </div>
                  </div>
                );
              })
          }
        </div>

        {/* Aylık başvurular */}
        <div className="card">
          <div className="card-header">
            <span className="card-title">{yil} Aylık Başvurular</span>
          </div>
          <div style={{display:'flex', alignItems:'flex-end', gap:'4px', height:'120px'}}>
            {AYLAR.map((ayKisa, i) => {
              const veri = istatistik.aylik.find(a => parseInt(a.ay) === i + 1);
              const sayi = veri ? parseInt(veri.sayi) : 0;
              const yukseklik = maxAylik > 0 ? (sayi / maxAylik * 100) : 0;
              const secili = ay === i + 1;
              return (
                <div
                  key={ayKisa}
                  style={{flex:1, display:'flex', flexDirection:'column', alignItems:'center', gap:'4px', cursor:'pointer'}}
                  onClick={() => setAy(ay === i + 1 ? 0 : i + 1)}
                  title={`${AY_ADLARI[i]}: ${sayi} kayıt`}
                >
                  <span style={{fontSize:'10px', color: secili ? '#3949ab' : '#666', fontWeight: secili ? '700' : '400'}}>{sayi || ''}</span>
                  <div style={{
                    width:'100%', height:`${yukseklik}%`, minHeight: sayi > 0 ? '4px' : '0',
                    background: secili ? '#f57f17' : '#3949ab',
                    borderRadius:'2px 2px 0 0', transition:'height 0.5s',
                    outline: secili ? '2px solid #f57f17' : 'none'
                  }} />
                  <span style={{fontSize:'10px', color: secili ? '#3949ab' : '#888', fontWeight: secili ? '700' : '400'}}>{ayKisa}</span>
                </div>
              );
            })}
          </div>
          {ay > 0 && (
            <div style={{marginTop:'8px', textAlign:'center'}}>
              <button
                onClick={() => setAy(0)}
                style={{fontSize:'11px', color:'#3949ab', background:'none', border:'none', cursor:'pointer', textDecoration:'underline'}}
              >
                ✕ {AY_ADLARI[ay-1]} filtresini kaldır
              </button>
            </div>
          )}
        </div>

        {/* Faaliyet sınıfı dağılımı */}
        <div className="card">
          <div className="card-header">
            <span className="card-title">Faaliyet Sınıfı Dağılımı — {baslik}</span>
          </div>
          {istatistik.faaliyet_sinifi.filter(f => f.sinif_adi).length === 0
            ? <p style={{color:'#999', fontSize:'13px', textAlign:'center', padding:'20px'}}>Bu dönemde kayıt yok</p>
            : istatistik.faaliyet_sinifi.filter(f => f.sinif_adi).map(f => (
                <div key={f.sinif_adi} style={{display:'flex', justifyContent:'space-between', padding:'8px 0', borderBottom:'1px solid #f5f5f5'}}>
                  <span style={{fontSize:'13px'}}>{f.sinif_adi || 'Belirtilmemiş'}</span>
                  <span className="badge badge-basvuru">{f.sayi}</span>
                </div>
              ))
          }
        </div>

        {/* Hızlı erişim */}
        <div className="card">
          <div className="card-header">
            <span className="card-title">Hızlı İşlemler</span>
          </div>
          <div style={{display:'flex', flexDirection:'column', gap:'10px'}}>
            <a href="/ruhsat/yeni" className="btn btn-primary">➕ Yeni Ruhsat Başvurusu</a>
            <a href="/ruhsat?durum=BASVURU" className="btn btn-outline">📋 Bekleyen Başvurular</a>
            <a href="/sicil/yeni" className="btn btn-secondary">👤 Yeni Sicil Kaydı</a>
            <a href="/tanimlar" className="btn btn-secondary">📚 Tanımlara Git</a>
          </div>
        </div>
      </div>
    </div>
  );
}
